<template>
  <BaseWrapper :loading="loadingData">
    <div class="mb-4 flex justify-end gap-2">
      <OfficeSelectSearch
        :shadow="false"
        :office-category-id="4"
        v-model="filter.office"
        @change="loadBalanceTrxes"
      />
      <BaseSelect
        :shadow="false"
        :options="[
          { key: 'all', value: null, label: 'Semua' },
          { key: 'paid', value: true, label: 'Lunas' },
          { key: 'unpaid', value: false, label: 'Belum Lunas' },
        ]"
        v-model="filter.paid"
        @change="loadBalanceTrxes"
      ></BaseSelect>
    </div>
    <Datatable
      :total="balanceTrxes.meta.page.total"
      :perPage="balanceTrxes.meta.page.perPage"
      :currentPage="balanceTrxes.meta.page.currentPage"
      @pagechanged="onChangePage"
      :columns="[
        { name: 'Tanggal', id: 'createdAt' },
        { name: 'Kode Kantor', id: 'office_code' },
        { name: 'Jumlah', id: 'debt_amount' },
        { name: 'Deskripsi', id: 'description' },
        { name: 'Status', id: 'status' },
      ]"
    >
      <template #tbody="{ classes }">
        <tr
          v-for="balanceTrx in balanceTrxes.data"
          :key="balanceTrx.id"
          :class="[classes.tr, 'cursor-pointer bg-white hover:bg-gray-50']"
          @click="
            $router.push({
              name: `${
                trxType === 'topup_stockist_debt'
                  ? 'migrasi-saldo-kurang-bayar-stockist'
                  : 'migrasi-saldo-kurang-bayar-sc'
              }.detail`,
              params: { id: balanceTrx.id },
            })
          "
        >
          <td :class="classes.td">
            {{ balanceTrx.attributes.createdAt | formatDate }}
          </td>
          <td :class="classes.td">
            {{
              getSingleIncluded(
                balanceTrxes,
                balanceTrx.relationships.office.data.id
              ).attributes.code
            }}
          </td>
          <td :class="classes.td">
            {{
              balanceTrx.attributes[
                trxType === 'topup_stockist_debt'
                  ? 'order_debt_balance_amount'
                  : 'debt_amount'
              ] | toCurrency
            }}
          </td>
          <td :class="classes.td">
            {{ balanceTrx.attributes.description }}
          </td>
          <td :class="classes.td">
            <BaseBadge
              :color="balanceTrx.attributes.paid ? 'green' : 'yellow'"
              >{{
                balanceTrx.attributes.paid ? 'Lunas' : 'Belum Lunas'
              }}</BaseBadge
            >
          </td>
        </tr>
      </template>
    </Datatable>
  </BaseWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import { requestMixin } from '../../../../../mixins/request/request';
import { mapActions } from 'vuex';
import OfficeSelectSearch from '../../../../../components/office/office-select-search.vue';
import BaseBadge from '../../../../../components/base/BaseBadge.vue';

export default {
  props: {
    trxType: String,
  },
  components: {
    OfficeSelectSearch,
    BaseBadge,
  },
  mixins: [requestMixin],
  data() {
    return {
      balanceTrxes: {
        data: [],
        meta: {
          page: {},
        },
      },
      filter: {
        search: null,
        paid: false,
        office: {
          attributes: {},
        },
      },
      form: {
        code: null,
        name: null,
        description: null,
        is_global: true,
      },
      loadingData: true,
      loadingSubmit: false,
      loadingDelete: false,
      addModal: {
        id: null,
        visible: false,
      },
      deleteConfirm: {
        id: null,
        visible: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
    }),
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadBalanceTrxes(params = {}) {
      this.loadingData = true;

      const [res, err] = await this.request(`/api/v1/balance-trxes`, {
        params: {
          'page[size]': 5,
          sort: '-createdAt',
          include: 'office',
          'fields[balance-trxes]':
            'createdAt,debt_amount,order_debt_balance_amount,office,description,paid',
          'fields[offices]': 'code',
          'filter[trx_type]': this.trxType,
          'filter[office_uuid]': this.filter.office.attributes?.office_id,
          'filter[paid]': this.filter.paid,
          // 'filter[checked]': false,
          ...params,
        },
      });

      if (!err) {
        this.balanceTrxes = res;
      }

      this.loadingData = false;
    },
    onChangePage(page) {
      this.loadBalanceTrxes({ 'page[number]': page });
    },
  },
  created() {
    this.loadBalanceTrxes();
  },
};
</script>
